// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2U9no","description":"PatientConsentPreview_description__1l7jg"};